module.exports = __webpack_public_path__ + "static/media/Tutoriais-sistem.ef00677e.jpg";